var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEscolar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 38,
    viewBox: "0 0 47 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0511 37.5565L7.55108 29.1323V16.6134L0 12.5188L23.0511 0L46.1022 12.5188V29.0134H43.5188V13.9707L38.5511 16.6134V29.1323L23.0511 37.5565ZM23.0511 22.0772L40.6952 12.5188L23.0511 2.9605L5.40692 12.5188L23.0511 22.0772ZM23.0511 34.6115L35.9678 27.6365V18.0343L23.0511 25.0299L10.1344 18.0343V27.6365L23.0511 34.6115Z",
    fill: "#303376"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEscolar);
export default __webpack_public_path__ + "static/media/ic_escolar.b552ab8efaaa57729c67a1b988af5701.svg";
export { ForwardRef as ReactComponent };